import React from 'react'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'

import { startLogout } from '../../redux/actions/auth'

export const CerrarSesion = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleLogout = () => {
        dispatch(startLogout());
        navigate('/', { replace: true });
    }

    return (
        <button
            className='btn p-btn-primary-cerrar-sesion m-3'
            onClick={handleLogout}
        >
            Cerrar Sesión
        </button>
    )
}
